import { z } from 'zod'

export const venuePanels = ['overview', 'services', 'logistics', 'organization'] as const
export type VenuePanel = (typeof venuePanels)[number]

export const venuePanelLabels: Record<VenuePanel, string> = {
  overview: 'Přehled',
  services: 'Služby',
  logistics: 'Logistika',
  organization: 'Organizace',
}

const legacyPanels: Record<string, VenuePanel> = {
  operations: 'organization',
  documents: 'overview',
}

const panelSchema = z.enum(venuePanels)

/** Reads `panel`, mapping the removed Provoz and Dokumenty tabs (formerly `tab`) to their nearest tab. */
export function parseVenueSearch(search: Record<string, unknown>): { panel?: VenuePanel } {
  const requested = search.panel ?? search.tab
  const panel =
    typeof requested === 'string'
      ? (legacyPanels[requested] ?? panelSchema.safeParse(requested).data)
      : undefined
  return panel ? { panel } : {}
}

export function isLegacyVenueSearch(search: Record<string, unknown>) {
  return 'tab' in search || (typeof search.panel === 'string' && search.panel in legacyPanels)
}
